/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ChecklistTemplate,
    ChecklistTemplateFromJSON,
    ChecklistTemplateToJSON,
} from '../models/ChecklistTemplate';
import {
    type TemplateSummaryResponse,
    TemplateSummaryResponseFromJSON,
    TemplateSummaryResponseToJSON,
} from '../models/TemplateSummaryResponse';

export interface CreateTemplateRequest {
    /**
     * 
     */
    checklistTemplate: ChecklistTemplate;
}

export interface DeleteTemplateRequest {
    /**
     * 
     */
    id: string;
}

export interface GetTemplateRequest {
    /**
     * 
     */
    id: string;
}

export interface PublishTemplateRequest {
    /**
     * 
     */
    id: string;
}

export interface UpdateTemplateRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    checklistTemplate: ChecklistTemplate;
}

/**
 * 
 */
export class ChecklistTemplateControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for createTemplate without sending the request
     */
    async createTemplateRequestOpts(requestParameters: CreateTemplateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['checklistTemplate'] == null) {
            throw new runtime.RequiredError(
                'checklistTemplate',
                'Required parameter "checklistTemplate" was null or undefined when calling createTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/checklist-templates`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChecklistTemplateToJSON(requestParameters['checklistTemplate']),
        };
    }

    /**
     */
    async createTemplateRaw(requestParameters: CreateTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChecklistTemplate>> {
        const requestOptions = await this.createTemplateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChecklistTemplateFromJSON(jsonValue));
    }

    /**
     */
    async createTemplate(requestParameters: CreateTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChecklistTemplate> {
        const response = await this.createTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteTemplate without sending the request
     */
    async deleteTemplateRequestOpts(requestParameters: DeleteTemplateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/checklist-templates/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteTemplateRaw(requestParameters: DeleteTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteTemplateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTemplate(requestParameters: DeleteTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTemplateRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAllTemplates without sending the request
     */
    async getAllTemplatesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/checklist-templates`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TemplateSummaryResponse>>> {
        const requestOptions = await this.getAllTemplatesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TemplateSummaryResponseFromJSON));
    }

    /**
     */
    async getAllTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TemplateSummaryResponse>> {
        const response = await this.getAllTemplatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTemplate without sending the request
     */
    async getTemplateRequestOpts(requestParameters: GetTemplateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/checklist-templates/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getTemplateRaw(requestParameters: GetTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TemplateSummaryResponse>> {
        const requestOptions = await this.getTemplateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TemplateSummaryResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTemplate(requestParameters: GetTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TemplateSummaryResponse> {
        const response = await this.getTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for publishTemplate without sending the request
     */
    async publishTemplateRequestOpts(requestParameters: PublishTemplateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling publishTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/checklist-templates/{id}/publish`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async publishTemplateRaw(requestParameters: PublishTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChecklistTemplate>> {
        const requestOptions = await this.publishTemplateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChecklistTemplateFromJSON(jsonValue));
    }

    /**
     */
    async publishTemplate(requestParameters: PublishTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChecklistTemplate> {
        const response = await this.publishTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateTemplate without sending the request
     */
    async updateTemplateRequestOpts(requestParameters: UpdateTemplateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTemplate().'
            );
        }

        if (requestParameters['checklistTemplate'] == null) {
            throw new runtime.RequiredError(
                'checklistTemplate',
                'Required parameter "checklistTemplate" was null or undefined when calling updateTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/checklist-templates/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChecklistTemplateToJSON(requestParameters['checklistTemplate']),
        };
    }

    /**
     */
    async updateTemplateRaw(requestParameters: UpdateTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChecklistTemplate>> {
        const requestOptions = await this.updateTemplateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChecklistTemplateFromJSON(jsonValue));
    }

    /**
     */
    async updateTemplate(requestParameters: UpdateTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChecklistTemplate> {
        const response = await this.updateTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
